import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";

import Navbar from "./Components/Navbar/Navbar";
import PageTracking from "./Utils/pageTracking";
import Join from "./Views/Join/Join";
import Login from "./Views/Join/Login/Login";
import Register from "./Views/Join/Register/Register";
import Status from "./Views/Join/Status/Status";
import VerifyEmail from "./Views/Join/Verify/Verify";
import AlreadyAssigned from "./Views/Join/AlreadyAssigned/AlreadyAssigned";

const App = () => {
  PageTracking();

  return (
    <div className="App position-relative">
      {/* global components */}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        // autoClose={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        closeButton={true}
      />

      <Navbar />

      {/* routes */}
      <Routes>
        <Route path="/" element={<Join />} />
        <Route path="/verifyemail/:id/:id" element={<VerifyEmail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/already-assigned" element={<AlreadyAssigned />} />
        <Route path="/register" element={<Register />} />
        <Route path="/status" element={<Status />} />
        <Route path="*" element={<Join />} />
      </Routes>
    </div>
  );
};

export default App;
